import { DEFAULT_FONT_FAMILY } from '../../constants';

export const xAxisStyle = {
  axis: { stroke: 'none' },
  tickLabels: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: 14,
    fill: '#A0A3B9',
  },
};

export const CHART_HEIGHT = 201;
export const CHART_WIDTH = 524;
export const DATUM_SELECTOR = 'datum';
